export const resourceTypeSearchParam = "rt";

export const accountIdsSearchParam = "accountIds";

export const accountsPageTabSearchParam = "accountsType";

export const resourceIdSearchParam = "resourceId";
